import React from 'react';
import { useHistory } from 'react-router-dom';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CardContent from './CardContent';

const useStyles = makeStyles((theme: any) => ({
  businessButtonsWrap: {
    marginRight: theme.spacing(12),
  },
}));

export default function BusinessCardContent(props) {
  const classes = useStyles();
  const history = useHistory();
  const { companyData } = props;
  const businessAttrs = {
    name: {
      label: 'Business name',
      value: companyData.name,
    },
    store_url: {
      label: 'Store URL',
      value: companyData.storeUrl,
    },
  };
  const buttonsMap = {
    edit: {
      id: 'edit',
      label: 'Edit',
      callback: () => history.push('/account/business'),
    },
  };
  return (
    <CardContent
      attributesMap={businessAttrs}
      buttonsMap={buttonsMap}
      buttonsWrapClass={classes.businessButtonsWrap}
    />
  );
}
